import { render, staticRenderFns } from "./ApplicationsWiseStudents.vue?vue&type=template&id=43310a46&scoped=true&"
import script from "./ApplicationsWiseStudents.vue?vue&type=script&lang=js&"
export * from "./ApplicationsWiseStudents.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsWiseStudents.vue?vue&type=style&index=0&id=43310a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43310a46",
  null
  
)

export default component.exports